import { render, staticRenderFns } from "./companyDialog.vue?vue&type=template&id=dd1a470c&scoped=true"
import script from "./companyDialog.vue?vue&type=script&lang=js"
export * from "./companyDialog.vue?vue&type=script&lang=js"
import style0 from "./companyDialog.vue?vue&type=style&index=0&id=dd1a470c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1a470c",
  null
  
)

export default component.exports